import { createElementVNode as _createElementVNode, openBlock as _openBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-full",
  width: "18",
  height: "10",
  viewBox: "0 0 18 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.820312 0.818359L9.00213 9.00018L17.1839 0.818359",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-[13px]" }, "Advanced", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_collapse_transition = _resolveComponent("n-collapse-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = !_ctx.show)),
      class: "flex items-center cursor-pointer my-3 opacity-80"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-3 m-2 transition-all", { 'rotate-180': _ctx.show }])
      }, _hoisted_3, 2),
      _hoisted_4
    ]),
    _createVNode(_component_n_collapse_transition, { show: _ctx.show }, {
      default: _withCtx(() => [
        (_ctx.text)
          ? (_openBlock(), _createBlock(_component_n_alert, {
              key: 0,
              type: "info"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.text), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["show"])
  ]))
}